import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {Button, Tooltip} from "reactstrap";
import classnames from "classnames";

class DisplayName extends Component {

  constructor(props) {
    super(props);
    this.state = {
      block: {
        displayName: props.block.displayName,
      },
      tooltip: false
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.toggleDisplayName = this.toggleDisplayName.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    });
  }

  toggleDisplayName() {
    this.setState({
      block: {
        displayName: !this.state.block.displayName
      }
    }, () => {
      this.props.handleUpdate(this.state.block)
    });
  }

  render() {
    let { tooltip } = this.state;
    return (
      <Button
        className={classnames({
          "float-left mr-1 btn-icon mb-1": true,
          "active": this.state.block.displayName
        })}
        color={'secondary'}
        id="displayName"
        onClick={this.toggleDisplayName}
      >
        <i className="fas fa-eye" />

        <Tooltip
          delay={0}
          placement="top"
          isOpen={tooltip}
          target="displayName"
          toggle={() => this.toggleTooltip()}
        >
          <FormattedMessage id="block.settings.displayName.button.tooltip"/>
        </Tooltip>
      </Button>
    )
  }
}

DisplayName.propTypes = {
  block: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default DisplayName;